import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Link from 'next/link';
import { map } from '@cullylarson/f';
import { getStateFromAbbrev } from '@@client/lib/locations';

var StateStoresSimple = function StateStoresSimple(_ref) {
  var stores = _ref.stores,
      stateAbbrev = _ref.stateAbbrev,
      highlightedLocationId = _ref.highlightedLocationId,
      _ref$onLocationClick = _ref.onLocationClick,
      onLocationClick = _ref$onLocationClick === void 0 ? null : _ref$onLocationClick,
      _ref$onLocationEnter = _ref.onLocationEnter,
      onLocationEnter = _ref$onLocationEnter === void 0 ? function () {} : _ref$onLocationEnter,
      _ref$onLocationLeave = _ref.onLocationLeave,
      onLocationLeave = _ref$onLocationLeave === void 0 ? function () {} : _ref$onLocationLeave,
      _ref$getStoreName = _ref.getStoreName,
      getStoreName = _ref$getStoreName === void 0 ? function (storeInfo) {
    return storeInfo.name || storeInfo.city;
  } : _ref$getStoreName;
  var state = getStateFromAbbrev(stateAbbrev);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1482221989" + " " + 'container',
      children: [/*#__PURE__*/_jsx("h2", {
        className: "jsx-1482221989",
        children: state
      }), /*#__PURE__*/_jsx("ul", {
        className: "jsx-1482221989",
        children: stores.map(function (x) {
          return /*#__PURE__*/_jsx("li", {
            className: "jsx-1482221989" + " " + ((highlightedLocationId === x.id ? 'is-highlighted' : null) || ""),
            children: onLocationClick === null ? /*#__PURE__*/_jsx(Link, {
              href: "/locations/[slug]",
              as: "/locations/".concat(x.slug),
              children: /*#__PURE__*/_jsx("a", {
                onMouseEnter: function onMouseEnter() {
                  return onLocationEnter(x);
                },
                onMouseLeave: function onMouseLeave() {
                  return onLocationLeave(x);
                },
                className: "jsx-1482221989",
                children: getStoreName(x)
              })
            }) : /*#__PURE__*/_jsx("button", {
              onMouseEnter: function onMouseEnter() {
                return onLocationEnter(x);
              },
              onMouseLeave: function onMouseLeave() {
                return onLocationLeave(x);
              },
              onClick: function onClick() {
                return onLocationClick(x);
              },
              className: "jsx-1482221989" + " " + 'm--as-link',
              children: getStoreName(x)
            })
          }, x.id);
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1482221989",
      children: ["@media(max-width:400px){.container.jsx-1482221989{margin-bottom:20px;}}", "ul.jsx-1482221989{list-style:none;margin:0;padding:0;}", "li.jsx-1482221989{margin-top:10px;}", "li.jsx-1482221989 button.jsx-1482221989,li.jsx-1482221989 a.jsx-1482221989{padding:5px 18px;-webkit-text-decoration:none;text-decoration:none;}", "li.is-highlighted.jsx-1482221989 button.jsx-1482221989,li.is-highlighted.jsx-1482221989 a.jsx-1482221989{border-radius:3px;background:#FFDD15;-webkit-text-decoration:none;text-decoration:none;color:#21409A;}", "h2.jsx-1482221989{background:#F0F1F6;text-transform:uppercase;padding:6px 18px;color:#21409A;font-size:0.9375rem;}"]
    })]
  });
};

export default function StoreListSimple(_ref2) {
  var locationsGrouped = _ref2.locationsGrouped,
      stateStoresSimpleProps = _objectWithoutProperties(_ref2, ["locationsGrouped"]);

  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.values(map(function (stores, stateAbbrev) {
      return /*#__PURE__*/_jsx(StateStoresSimple, _objectSpread({
        stores: stores,
        stateAbbrev: stateAbbrev
      }, stateStoresSimpleProps), stateAbbrev);
    }, locationsGrouped))
  });
}